module.exports = __webpack_public_path__ + "img/zhinengbig.f629d21e.gif";